import Image from "next/image";

export type WhatsAppIconVariant = "color" | "mono";

export interface WhatsAppIconProps {
  readonly className?: string;
  readonly variant: WhatsAppIconVariant;
}

const whatsappIconSources: Record<WhatsAppIconVariant, string> = {
  color: "/icons/whatsapp-color-svgrepo-com.svg",
  mono: "/icons/whatsapp-svgrepo-com.svg",
};

export function WhatsAppIcon({
  className,
  variant,
}: Readonly<WhatsAppIconProps>) {
  return (
    <Image
      alt=""
      aria-hidden="true"
      className={className}
      height={24}
      src={whatsappIconSources[variant]}
      width={24}
    />
  );
}
